import { store } from '../app';

export default { ...store.modules };



// WEBPACK FOOTER //
// ./src/store/modules.js